module.exports = __webpack_public_path__ + "static/img/wx.d44626a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qcode/wx.jpg
// module id = fVVW
// module chunks = 3